const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export const resolveUrl = (p) => (!p ? '' : /^(https?:|data:|blob:)/.test(p) ? p : `${BACKEND}${p}`);

const readAsDataURL = (f) => new Promise((res, rej) => {
  const r = new FileReader();
  r.onload = () => res(String(r.result));
  r.onerror = rej;
  r.readAsDataURL(f);
});

// Shrink to max 1600px JPEG in the browser when it can decode the file; otherwise send raw (server converts HEIC).
export const fileToUploadB64 = async (f, maxSide = 1600) => {
  try {
    const url = URL.createObjectURL(f);
    const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; });
    const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement('canvas');
    c.width = Math.round(img.naturalWidth * scale);
    c.height = Math.round(img.naturalHeight * scale);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    return c.toDataURL('image/jpeg', 0.85);
  } catch {
    return readAsDataURL(f);
  }
};

const enc = encodeURIComponent;
export const googleMapsUrl = (from, to) => {
  if (from && to) return `https://www.google.com/maps/dir/?api=1&waypoints=${enc(from)}&destination=${enc(to)}&travelmode=driving`;
  return `https://www.google.com/maps/dir/?api=1&destination=${enc(from || to || '')}&travelmode=driving`;
};
export const wazeUrl = (pc) => `https://waze.com/ul?q=${enc(pc)}&navigate=yes`;

export const balanceDue = (b) => Math.max(0, (b.booking?.final_price ?? b.price ?? 0) - (b.deposit_claimed_at ? (b.deposit || 0) : 0));
